<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			名片收益
		</div>
		
		<div @click="isShow = !isShow" style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加名片收益
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;">
				添加
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="height: 300px;text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in mpa">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}} <span style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao" style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div" :to="{ path:'/txldetail',query:{id:item.id,title:item.title} }" style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			
			
			
			
			<div v-show="isShow">

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">

					</div>
					<el-select style="margin-top: 5px;" v-model="form.fid" filterable placeholder="请选择">
						<el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						姓名:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<!-- <div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						邮箱:
					</div>
					<el-input v-model="form.email" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						地址:
					</div>
					<el-input v-model="form.address" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						手机号码:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						职位:
					</div>
					<el-input v-model="form.position" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

			<!-- 	<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						网址:
					</div>
					<el-input v-model="form.web" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
 -->
				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						公司名:
					</div>
					<el-input v-model="form.company" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>


				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				optionss: [{
					value: '14',
					label: '设计院所公司'
				}, {
					value: '13',
					label: '海上风电公司'
				}, {
					value: '12',
					label: '平台船东业主'
				}, {
					value: '15',
					label: '造修拆船厂'
				}, {
					value: '16',
					label: '科研院所'
				}, {
					value: '17',
					label: '认证检测试验'
				}, {
					value: '18',
					label: '船海高校培训'
				}, {
					value: '19',
					label: '船海学会协会'
				}, {
					value: '20',
					label: '报刊书编辑出版'
				}, {
					value: '21',
					label: '展会会议服务'
				}, {
					value: '22',
					label: '金融法务翻译'
				}, {
					value: '23',
					label: '动力装置'
				}, {
					value: '24',
					label: '辅机设备'
				}, {
					value: '25',
					label: '电气装置'
				}, {
					value: '26',
					label: '自动化系统'
				}, {
					value: '27',
					label: '甲板机械'
				}, {
					value: '29',
					label: '舾装设备'
				}, {
					value: '31',
					label: '船舶通信'
				}, {
					value: '32',
					label: '船舶导航'
				}, {
					value: '34',
					label: '救生装备'
				}, {
					value: '35',
					label: '消防设备'
				}, {
					value: '36',
					label: '节能环保'
				}, {
					value: '37',
					label: '船用材料'
				}, {
					value: '38',
					label: '船用钢材'
				}, {
					value: '39',
					label: '生活用品'
				}, {
					value: '40',
					label: '安全用品'
				}, {
					value: '41',
					label: '造修装备'
				}, ],
				fileListss: [],
				form: {
					picurl: '', //名片
					title: '', //姓名
					email: '', //邮箱
					address: '', //地址
					phone: '', //手机号
					position: '', //职位
					web: '', //网址
					company: '', //公司名
					fid: '', //名片分类
				},
				xsa: false,
				qid: '',
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				mpa: '',
			}
		},
		mounted() {
			this.gotosb()
		},
		methods: {
			handlePreview(file) {
				console.log(file);
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
					let res = await http.get('api/picture/personl_page_mpsx', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.mpa = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccessss(response, file, fileList) {
				this.form.picurl = response.data.path
			},
			async detela(id, mid) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'bscard',
					type: 'content',
					mid: '5',
					uid: loginInfo.id,
					field_name: 'id',
					field_id: id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
					this.gotosb()
				}
			},
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/index', {
					model: 'bscard',
					type: 'content',
					mid: '5',
					uid: loginInfo.id
				})
				console.log(res.data.data)
				this.mpa = res.data.data.list.data
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			xiugaia(val){
				console.log(val)
				var sb = true
				this.isShow = true
				this.xsa = true
				this.form.title = val.title
				this.form.picurl = val.picurl
				// optionss
				// this.form.fid = val.fid
				// this.form.fid = this.optionss[val.fid].id
				// console.log(this.form.fid,val.fid)
				this.form.email = val.email
				this.form.company = val.company
				this.form.address = val.address
				this.form.phone = val.phone
				this.form.position = val.position
				this.form.web = val.web
				this.qid = val.id
				this.optionss.forEach((item=>{
					if(item.value==val.fid){
						this.form.fid = item.value
					}
				}))
				
				if(this.form.picurl === 'http://admin.shipoe360.com/public/'){
					this.form.picurl = ''
					sb = true
				} else {
					this.form.picurl = this.form.picurl.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
					sb = false
				}
				
				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name="图片";
				fileObjss.url = val.picurl;
				fileArrss.push(fileObjss);
				this.fileListss  = fileArrss
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.xsa == true) {
					let res = await http.post('api/Common/edit', {
						model: 'bscard',
						type: 'content',
						mid: '5',
						id: this.qid,
						fid: this.form.fid,
						title: this.form.title,
						picurl: this.form.picurl,
						company: this.form.company,
						address: this.form.address,
						phone: this.form.phone,
						email:this.form.email,
						position: this.form.position,
						web: this.form.web,
						uid: loginInfo.id
					})
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.gotosb()
						this.fileListss = []
						this.form.picurl = ''
						this.form.title = ''
						this.form.email = ''
						this.form.address = ''
						this.form.phone = ''
						this.form.position = ''
						this.form.web = ''
						this.form.company = ''
						this.form.fid = ''
					}
				} else if (this.xsa == false) {
					let res1 = await http.post('api/Common/add', {
						model: 'bscard',
						type: 'content',
						mid: '5',
						title: this.form.title,
						picurl: this.form.picurl,
						fid: this.form.fid,
						email:this.form.email,
						company: this.form.company,
						address: this.form.address,
						phone: this.form.phone,
						position: this.form.position,
						web: this.form.web,
						uid: loginInfo.id
					})
					if (res1.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '上传成功',
							type: 'success'
						});
						this.gotosb()
						this.fileListss = []
						this.form.picurl = ''
						this.form.title = ''
						this.form.email = ''
						this.form.address = ''
						this.form.phone = ''
						this.form.position = ''
						this.form.web = ''
						this.form.company = ''
						this.form.fid = ''
					}
				}
			}
		}
	}
</script>

<style>
</style>
